module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "title"
  }, [_vm._v("BlackList (ByBit/HTX)\n          "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Quick Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.quickSearch),
      callback: function($$v) {
        _vm.quickSearch = $$v
      },
      expression: "quickSearch"
    }
  })], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "search": _vm.search,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', [_vm._l((props.headers), function(header, index) {
          return _c('th', {
            key: header.text,
            class: ['column', 'subheading', index === 0 ? 'text-xs-left' : 'text-xs-center']
          }, [_vm._v("\n            " + _vm._s(header.text) + "\n          ")])
        }), _vm._v(" "), _c('th')], 2)]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_vm._l((_vm.headers), function(header, index) {
          return (header.value !== '') ? _c('td', {
            key: index,
            class: [index === 0 ? 'text-xs-left' : 'text-xs-center', 'body-2']
          }, [_vm._v("\n          " + _vm._s(_vm.renderData(props.item, header)) + "\n        ")]) : _vm._e()
        }), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-btn', {
          staticClass: "teal",
          attrs: {
            "fab": "",
            "small": "",
            "dark": ""
          },
          nativeOn: {
            "click": function($event) {
              _vm.view(props.item)
            }
          }
        }, [_c('v-icon', [_vm._v("list")])], 1)], 1)]
      }
    }])
  }, [_c('template', {
    slot: "no-data"
  }, [_c('span', [_c('p', {
    staticClass: "pt-2 blue--text subheading"
  }, [_c('v-icon', {
    staticClass: "blue--text",
    attrs: {
      "medium": ""
    }
  }, [_vm._v("info")]), _vm._v("Sorry, nothing to display here :(")], 1)])])], 2)], 1)], 1), _vm._v(" "), (_vm.loading === false) ? _c('v-snackbar', {
    attrs: {
      "right": true,
      "timeout": _vm.timeout,
      "color": _vm.mode
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.notice) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeSnackbar($event)
      }
    }
  }, [_vm._v("Close")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/vue-loader/lib/template-compiler?{"id":"data-v-eaaffd9a","hasScoped":false}!/Users/gtirby/develop/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BlackList.vue
// module id = 425
// module chunks = 0